(() => {
  const collectionSelector = '[data-product-format-collection]';
  const filterSelector = '[data-product-format-filters]';

  const getItems = (collection) => Array.from(collection.querySelectorAll('#product-grid > [data-product-id]'));

  const setButtonsDisabled = (filters, disabled) => {
    filters.querySelectorAll('[data-format-value]').forEach((button) => {
      button.disabled = disabled;
    });
  };

  const setActiveButton = (filters, value) => {
    filters.querySelectorAll('[data-format-value]').forEach((button) => {
      const active = button.dataset.formatValue === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  };

  const updateStatus = (filters, count, message = '') => {
    const status = filters.querySelector('[data-format-filter-status]');
    if (!status) return;

    if (message) {
      status.textContent = message;
      return;
    }

    const template = filters.dataset.visibleTemplate || '__COUNT__';
    status.textContent = template.replace('__COUNT__', String(count));
  };

  const appendPageProducts = (collection, documentFragment) => {
    const targetGrid = collection.querySelector('#product-grid');
    const sourceGrid = documentFragment.querySelector('#product-grid');
    if (!targetGrid || !sourceGrid) return;

    const knownIds = new Set(getItems(collection).map((item) => item.dataset.productId));
    const fragment = document.createDocumentFragment();

    sourceGrid.querySelectorAll(':scope > [data-product-id]').forEach((item) => {
      if (knownIds.has(item.dataset.productId)) return;
      knownIds.add(item.dataset.productId);
      fragment.append(item);
    });

    targetGrid.append(fragment);
  };

  const loadAllPages = async (collection, filters) => {
    if (collection.dataset.formatPagesLoaded === 'true') return true;

    const pageCount = Number.parseInt(collection.dataset.pageCount || '1', 10);
    const currentPage = Number.parseInt(collection.dataset.currentPage || '1', 10);

    if (pageCount <= 1) {
      collection.dataset.formatPagesLoaded = 'true';
      return true;
    }

    setButtonsDisabled(filters, true);
    updateStatus(filters, 0, filters.dataset.loadingLabel || '');

    try {
      const requests = [];
      for (let page = 1; page <= pageCount; page += 1) {
        if (page === currentPage) continue;

        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set('page', String(page));
        requests.push(
          fetch(pageUrl, { credentials: 'same-origin' }).then((response) => {
            if (!response.ok) throw new Error(`Unable to load collection page ${page}`);
            return response.text();
          })
        );
      }

      const pages = await Promise.all(requests);
      pages.forEach((html) => {
        const pageDocument = new DOMParser().parseFromString(html, 'text/html');
        appendPageProducts(collection, pageDocument);
      });

      collection.dataset.formatPagesLoaded = 'true';
      return true;
    } catch (error) {
      updateStatus(filters, 0, filters.dataset.errorLabel || '');
      return false;
    } finally {
      setButtonsDisabled(filters, false);
    }
  };

  const filterProducts = (collection, filters, value) => {
    const items = getItems(collection);
    let visibleCount = 0;

    items.forEach((item) => {
      const visible = !value || item.dataset.productFormat === value;
      item.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    setActiveButton(filters, value);
    updateStatus(filters, visibleCount);

    const empty = filters.querySelector('[data-format-filter-empty]');
    if (empty) empty.hidden = visibleCount !== 0;

    collection.classList.toggle('is-format-filtered', collection.dataset.formatPagesLoaded === 'true');
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(`${filterSelector} [data-format-value]`);
    if (!button) return;

    const filters = button.closest(filterSelector);
    const collection = filters.closest(collectionSelector);
    if (!collection) return;

    const value = button.dataset.formatValue || '';
    if (value && collection.dataset.formatPagesLoaded !== 'true') {
      const loaded = await loadAllPages(collection, filters);
      if (!loaded) {
        filterProducts(collection, filters, value);
        return;
      }
    }

    filterProducts(collection, filters, value);
  });
})();
